<template>
    <div>
        <div v-if="label" class="pb-1">
            <input-label :label_class="label_class"> {{ $t(label) }}</input-label>
        </div>

        <div class="flex-1 flex flex-col sm:flex-row items-start">
            <input-radio-multi
                :name="field"
                v-model="who"
                :options="types"
                :read_only="read_only"
                :nullable="true"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        field: {},
        value: {},
        label: {},
        label_class: {},
        read_only: { default: false },
    },

    data() {
        return {
            types: [
                { value: 'buyer', label: 'Buyer' },
                { value: 'seller', label: 'Seller' },
                { value: 'city', label: 'City' },
            ],
            who: this.value || null,
        }
    },

    watch: {
        value(value) {
            this.$emit('input', value);
        },
    },
}
</script>
